import {
  ActivityIndicator,
  Text,
  TextInput,
  View
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import { Formik } from 'formik'
import Card from '../../shared/card/Card'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import { mapSelectValue } from '../../../utils'
import CustomButton from '../../shared/button/Button'
import { useFormsStore } from '../../../stores/onboarding'
import * as yup from 'yup'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useInitializeStore } from '../../../stores/initialize'
import Toast from 'react-native-toast-message'

const WiInformationForm = ({ navigation, route }: any) => {
  const { params } = route
  const {
    mostRecentUserOnBoardings: userId,
    mode,
    essUserOnBoardingKey,
    essUserOnBoardingFormKey
  } = params
  const personalstore = usePersonalStore()
  const intializeStore = useInitializeStore()
  const { loading, postwionline } = useFormsStore()


  const options1 = [
    { key: 1, value: 'Single' },
    {
      key: 2, value: 'Married, expect to file a joint Wisconsin tax return'
    },
    {
      key: 3,
      value: 'Married, expect to file a separate Wisconsin tax return'
    },
    {
      key: 4,
      value: 'Head of Household'
    }

  ]
  const intialValues = {
    filingStatus: '',
    remainingAmount: "",
    remPayrolls: "",
    withholdAmount: ""

  }

  const w4schema = () => {
    const baseSchema = {
      filingStatus: yup.string().required('Filing Status is a required field'),
      remainingAmount: yup.string().required("Remaining Amount is a required field"),
      remPayrolls: yup.string().required("Remaining no of payrolls is a required field"),
      withholdAmount: yup.string().required("Withhold Amount for each payroll period is a required filed ")

    }
    return yup.object(baseSchema)
  }
  const schema = w4schema()




  return (
    <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel="Forms"
            navScreen="OnboardingForms"
            title={'WI Withholding Taxation'}
          />
        </View>
      </View>
      <View style={globalStyles.containerOverlap}>
        <Formik
          initialValues={{ ...intialValues }}
          validationSchema={schema}
          onSubmit={async (values, actions) => {

            const data = {
              entityId: personalstore?.personalData?.entityId,
              essUserKey: intializeStore?.initializeData?.userkey,
              essObKey: essUserOnBoardingKey,
              essUserOnBoardingFormKey: essUserOnBoardingFormKey,
              completeOnline: mode === 'online' ? true : false,
              maritalStatus: values?.filingStatus,
              remainingAmount: Number(values?.remainingAmount) || null,
              remPayrolls: Number(values?.remPayrolls) || null,
              withholdAmount: Number(values?.withholdAmount) || null
            }
            const response: any = await postwionline(data)

            if (response?.success) {
              if (mode === 'upload') {
                await Toast.show({
                  type: 'success',
                  position: 'bottom',
                  text1: response?.message,
                  visibilityTime: 3000,
                  autoHide: true,
                  topOffset: 60,
                  onHide: () => {
                    navigation.replace('OnboardingForms')
                  }
                })
              } else {
                navigation.navigate('WiInformationOnline', {
                  userId,
                  mode,
                  essUserOnBoardingKey,
                  essUserOnBoardingFormKey,
                  values,
                })
              }
            } else {
              await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
              })
            }
          }}
        >
          {(props) => (
            <>
              <Card>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View
                    style={{
                      justifyContent: 'center',
                      width: '50%',
                      overflow: 'hidden'
                    }}
                  >
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Filing Status *'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <SelectKeyValue
                      title="Filing Status"
                      options={options1}
                      selectedOption={mapSelectValue(
                        options1,
                        props.values.filingStatus
                      )}
                      onSelect={(option: any) => {
                        props.setFieldValue('filingStatus', option - 1)
                      }}
                      textColor="primary"
                    />
                    {props.touched.filingStatus &&
                      props.errors.filingStatus && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.filingStatus as string}
                        </Text>
                      )}
                  </View>
                </View>

                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ width: '70%', justifyContent: 'center' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Enter the remaining amount to be withheld *'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <TextInput
                      style={[globalStyles.input, globalStyles.inputLight]}
                      value={props.values.remainingAmount}
                      keyboardType="numeric"
                      onChangeText={(text) => {
                        if (text === '' || /^\d+$/.test(text)) {
                          props.handleChange('remainingAmount')(text)
                        }
                      }}
                    />
                    {props.touched.remainingAmount && props.errors.remainingAmount && (
                      <Text style={globalStyles.dangerAlert}>
                        {props.errors.remainingAmount as string}
                      </Text>
                    )}
                  </View>
                </View>

                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ width: '70%', justifyContent: 'center' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Enter the remaining number of payroll periods for 2026 *'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <TextInput
                      style={[globalStyles.input, globalStyles.inputLight]}
                      value={props.values.remPayrolls}
                      keyboardType="numeric"
                      onChangeText={(text) => {
                        if (text === '' || /^\d+$/.test(text)) {
                          props.handleChange('remPayrolls')(text)
                        }
                      }}
                    />
                    {props.touched.remPayrolls && props.errors.remPayrolls && (
                      <Text style={globalStyles.dangerAlert}>
                        {props.errors.remPayrolls as string}
                      </Text>
                    )}
                  </View>
                </View>

                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ width: '70%', justifyContent: 'center' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Amount to be withheld each payroll period *'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <TextInput
                      style={[globalStyles.input, globalStyles.inputLight]}
                      value={props.values.withholdAmount}
                      keyboardType="numeric"
                      onChangeText={(text) => {
                        if (text === '' || /^\d+$/.test(text)) {
                          props.handleChange('withholdAmount')(text)
                        }
                      }}
                    />
                    {props.touched.withholdAmount && props.errors.withholdAmount && (
                      <Text style={globalStyles.dangerAlert}>
                        {props.errors.withholdAmount as string}
                      </Text>
                    )}
                  </View>
                </View>

                {loading ? (
                  <ActivityIndicator />
                ) : (
                  <View style={{ margin: 10 }}>
                    <CustomButton
                      text={mode === 'upload' ? 'Submit Information' : 'Next'}
                      onPress={props.handleSubmit}
                    />
                  </View>
                )}
              </Card>
            </>
          )}
        </Formik>
      </View>

    </KeyboardAwareScrollView>
  )
}

export default WiInformationForm
